import Select from "react-select";

export type PeriodOption = "daily" | "weekly" | "monthly";

interface OptionType {
  value: PeriodOption;
  label: string;
}

const options: OptionType[] = [
  { value: "weekly", label: "주간" },
  { value: "monthly", label: "월간" },
  { value: "daily", label: "일간" },
];

interface PeriodSelectProps {
  value: PeriodOption;
  onChange: (value: PeriodOption) => void;
}

const PeriodSelect = ({ value, onChange }: PeriodSelectProps) => {
  const selected = options.find((opt) => opt.value === value);

  return (
    <Select
      value={selected}
      onChange={(option) => option && onChange(option.value)}
      options={options}
      styles={{
        container: (base) => ({
          ...base,
          width: 112,
          fontSize: "14px",
          borderColor: "#CBCBCB",
        }),
        control: (base) => ({
          ...base,
          borderColor: "#ccc",
          minHeight: "48px",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.4)",
        }),
        dropdownIndicator: (base) => ({
          ...base,
          padding: "4px",
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "0 8px",
        }),
      }}
    />
  );
};

export default PeriodSelect;
